<template>
  <a-locale-provider :locale="zh_CN">
    <div id="app">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
  </a-locale-provider>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      zh_CN,
      isRouterAlive: true,
    };
  },
  created() {
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
    });
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem("messageStore") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem("messageStore"))
        )
      );
      let browser = this.browser();
      console.log(browser)
      if(browser){
        if((browser.chrome && browser.chrome<96) || (browser.safari && browser.safari<935) || (browser.firefox && browser.firefox<95)){
            this.$message({
            showClose: true,
            message: '建议使用以下浏览器，以获得最佳体验，chrome96+以上版本，safari935+以上版本，firefox95+以上版本',
            type: 'warning',
            duration:5000,
            offset:40
          });
          return
        }
       
      }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 浏览器检查结果
    browser() {
      var ua = navigator.userAgent;
      var ret = {},
        webkit = ua.match(/WebKit\/([\d.]+)/),
        chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/),
        ie =
          ua.match(/MSIE\s([\d\.]+)/) ||
          ua.match(/(?:trident)(?:.*rv:([\w.]+))?/i),
        firefox = ua.match(/Firefox\/([\d.]+)/),
        safari = ua.match(/Safari\/([\d.]+)/),
        opera = ua.match(/OPR\/([\d.]+)/);

      webkit && (ret.webkit = parseFloat(webkit[1]));
      chrome && (ret.chrome = parseFloat(chrome[1]));
      ie && (ret.ie = parseFloat(ie[1]));
      firefox && (ret.firefox = parseFloat(firefox[1]));
      safari && (ret.safari = parseFloat(safari[1]));
      opera && (ret.opera = parseFloat(opera[1]));
      return ret;
    },
  },
};
</script>

<style lang="scss">
// .icon-shoucang{
//     font-size: 21px;
//     font-weight: 400;
//     color: #F2C222;
// }
// .icon-shoucang.collectioned{

// }
.xhnTextLogo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 20px;
  background: linear-gradient(90deg, #ff871b 0%, #ff5523 100%);
  border-radius: 2px;
  color: #fff;
  float: left;
  margin-right: 8px;
  margin-top: 2px;
}
.tip {
  min-width: 22px;
  height: 22px !important;
  background-color: #ff4747 !important;
  border: 1px solid #ffffff;
  border-radius: 22px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-tabs__header {
  border-color: transparent !important;
  border-bottom: 1px solid #e5e5e5 !important;
}
.ant-tabs-nav-container {
  height: 56px !important;
}
.ant-tabs-nav-wrap {
  background: #f6f6f6 !important;
}
.ant-tabs-tab {
  border: 3px solid transparent !important;
  border-radius: 0 !important;
  background: transparent !important;
  height: 57px !important;
  font-size: 18px !important;
  line-height: 55px !important;
}
.ant-tabs-tab-active {
  height: 57px !important;
  color: #ff7800;
  background: #fff !important;
  border: 3px solid #ff7800 !important;
  border-bottom: 1px solid #fff !important;
  z-index: 12;
}
.ant-tabs-nav-container:after {
  content: "";
  height: 0px;
  width: 100%;
  position: absolute;
  bottom: 0;
  border-bottom: 3px solid #ff7800 !important;
  z-index: 10;
  // background-color: #ff7800;
  left: 0;
}
.el-pagination {
  text-align: center !important;
}
.el-button {
  border-radius: 2px !important;
}
.el-button--primary {
  color: #fff !important;
}
.ant-modal-confirm {
  .ant-modal-wrap,
  .ant-modal-mask {
    z-index: 5000;
  }
}
.el-message {
  top: 30%;
}
// ant树形下拉控件样式修改
li.ant-select-selection__choice {
  height: 37px !important;
  display: flex;
  align-items: center;
  padding: 0 15px !important;
  background: #f77b0b36 !important;
  border: 1px solid transparent !important;
  border-radius: 4px !important;
  color: #f77b0b !important;
  overflow: visible !important;
  margin-right: 9px !important;
}
span.ant-select-selection__choice__remove {
  width: 19px;
  height: 19px;
  background-color: #f77b0b;
  border-radius: 50%;
  display: flex !important;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -9.5px !important;
  top: -5px;
  color: #fff !important;
  padding-right: 0px;
}
.ant-select-selection--multiple > ul > li,
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
  height: 37px;
  margin-top: 3px;
  line-height: 37px;
  color: #f77b0b;
}
</style>



// WEBPACK FOOTER //
// src/App.vue